// antd theme tokens, replacing the old overrides.less variables:
// @primary-color: #3d5a80; @layout-header-height: 48px (12 * 4);
// @layout-header-background: #3d5a80.
// Shared by the app ConfigProvider and the static-method holderRender in App.js.
export const antdTheme = {
	token: {
		colorPrimary: '#3d5a80',
		// v4's border-radius-base was 2px; v6's 6px default reads too round
		// for this portal. Derived radii (LG/SM/XS) scale from this seed.
		borderRadius: 2,
	},
	components: {
		Layout: {
			headerHeight: 48,
			headerBg: '#3d5a80',
		},
		// The modal CONTAINER keeps v6's default rounding (content/header use
		// borderRadiusLG, which the 2px seed would shrink to 4). Controls
		// inside modals resolve against the global seed and stay sharp.
		Modal: {
			borderRadiusLG: 8,
		},
		// Cards sit halfway: rounder than controls (seed-derived 4), squarer
		// than modals (8).
		Card: {
			borderRadiusLG: 6,
		},
	},
};
